import React from "react";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useTranslation} from "react-i18next";
import './Widget.css';

export function Widget() {
    const { t } = useTranslation();
    document.body.style.backgroundColor = appdata.backgroundColor;
    // @ts-ignore
    return (
        <div className="widgetStyle">
            {t("InvitationTicketsBalanse")}:{appdata.ticketBalance}
        </div>
    );
}
